import { Component, OnInit, ViewChild } from '@angular/core';
import { MatInput } from "@angular/material";
import { VernostServiceService } from "../../services/vernost-service.service";
import { DatePipe } from "@angular/common";
import { saveAs } from "file-saver";
import { forkJoin } from 'rxjs';
import airports from '../../../../airport.json';


@Component({
  selector: 'app-search-flights',
  templateUrl: './search-flights.component.html',
  styleUrls: ['./search-flights.component.css'],
  providers: [DatePipe]
})

export class SearchFlightsComponent implements OnInit {


  dataSource: any;
  loader: boolean = false;
  isFilterAvailable: boolean = false;

  @ViewChild("fromDate", { read: MatInput }) fromDate: MatInput;
  @ViewChild("toDate", { read: MatInput }) toDate: MatInput;

  tableData: {}[] = [];
  isSearchDataNotAvailable: boolean = false;
  isSearchBtnDisable: boolean = true;
  isResponseStatusFail: boolean = false;
  isDownloadBtnDisable: boolean = false;

  searchResultMessage: string = "No Result"

  originalUBAResponse: any = [];
  originalUBRResponse: any = [];

  commonSearchFlights: any = [];
  commonDownloadFlights: any = [];
  displayedColumns: string[] = ['flightDetails', 'flightType', 'noOfStops', 'deptTime', 'arrTime', 'earnPrice', 'redeemPrice'];

  tableColumnsData = [
    { dbColumnName: 'flightDetails', columnName: 'Flight Details' },
    { dbColumnName: 'flightType', columnName: 'Flight Type' },
    { dbColumnName: 'noOfStops', columnName: 'No. Of Stops' },
    { dbColumnName: 'deptTime', columnName: 'Departure Time' },
    { dbColumnName: 'arrTime', columnName: 'Arrival Time' },
    { dbColumnName: 'earnPrice', columnName: 'Accrual Price' },
    { dbColumnName: 'redeemPrice', columnName: 'Redeem Price' }
  ]

  /**
   * Order of keys should be same like how we are formatting our result after download or search.
   * Refer formatResultData function.
   */
  csvHeaderFileObj = {
    flightDetails: "Flight Details",
    flightType: "Flight Type",
    noOfStops: "No Of Stops",
    deptTime: "Deptarture Time",
    arrTime: "Arrival Time",
    earnPrice: "Accrual Price",
    redeemPrice: "Redeem Price",
    journeyDate: "Journey Date"
  }


  screentitle: string = "Search Flights - Comparer";
  earnSearchFlights: any = [];
  redeemSearchFlights: any = [];
  earnDownloadFlights: any = [];
  redeemDownloadFlights: any = [];
  earnDownloadFlightsResponse: any = [];
  redeemDownloadFlightsResponse: any = [];
  search_details: any = [];
  prev_searchDetails: any = [];
  adult_list: any = [
    { key: 2, value: "2" },
    { key: 3, value: "3" },
    { key: 4, value: "4" },
    { key: 5, value: "5" },
    { key: 6, value: "6" },
    { key: 7, value: "7" },
    { key: 8, value: "8" },
    { key: 9, value: "9" }
  ];
  child_list: any = [
    { key: 1, value: "1" },
    { key: 2, value: "2" },
    { key: 3, value: "3" },
    { key: 4, value: "4" },
    { key: 5, value: "5" },
    { key: 6, value: "6" },
    { key: 7, value: "7" },
    { key: 8, value: "8" }
  ];
  infant_list: any = [
    { key: 1, value: '1' }
  ];
  search_minTodate: any = new Date();
  search_minFromDate: any = new Date();
  cabin_class: any = [
    { key: "2", value: "Business" }
  ]
  isCityNameError: boolean = false;

  constructor(private vernostService: VernostServiceService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.search_details = this.getOriginalSearchObj();
    this.prev_searchDetails = this.getOriginalSearchObj();
  }

  searchData() {
    this.loader = true;
    this.isSearchDataNotAvailable = false;
    this.tableData = [];
    this.commonSearchFlights = [];
    this.getSearchResults("search");
  }



  getSearchResults(operation: string) {
    this.countryCodeHelper();
    this.search_details.triptype = this.search_details.bookingdate_to === "" ? "1" : "2";
    Object.assign(this.prev_searchDetails, this.search_details);

    let earnRequest = this.formatSearchRequest(this.search_details, true);
    let redeemRequest = this.formatSearchRequest(this.search_details, false);
    forkJoin([this.vernostService.getSearchFlights(earnRequest), this.vernostService.getSearchFlights(redeemRequest)]).subscribe((earnAndRedeemRes: any) => {

      this.originalUBAResponse = JSON.parse(JSON.stringify(earnAndRedeemRes[0]));
      this.originalUBRResponse = JSON.parse(JSON.stringify(earnAndRedeemRes[1]));

      if (earnAndRedeemRes[0].status !== undefined && earnAndRedeemRes[0].status === "failed") {
        this.isResponseStatusFail = true;
        this.loader = false;
        this.isSearchDataNotAvailable = true;
        this.searchResultMessage = earnAndRedeemRes[0].message;
        this.isSearchBtnDisable = true;
        return;
      }

      earnAndRedeemRes[0].result.result = earnAndRedeemRes[0].result.result.filter((item: any) => item.supplier === "Easemytrip");
      earnAndRedeemRes[1].result.result = earnAndRedeemRes[1].result.result.filter((item: any) => item.supplier === "Easemytrip");

      if (operation === "search") {
        // Search Case
        this.searchHelper(earnAndRedeemRes);
        if (!this.earnSearchFlights.result.length && !this.redeemSearchFlights.result.length && !this.commonSearchFlights.length) {
          this.isSearchDataNotAvailable = true;
          this.isDownloadBtnDisable = true;
        } else {
          this.isSearchDataNotAvailable = false;
        }
      } else if (operation === "download") {
        // Download Case
        this.downloadHelper(earnAndRedeemRes);
      } else {
        // Download Response Case
        this.downloadJSONResponse(this.originalUBAResponse, `${this.search_details.originCode.toUpperCase()}-${this.search_details.destinationCode.toUpperCase()}-UBA`);
        this.downloadJSONResponse(this.originalUBRResponse, `${this.search_details.originCode.toUpperCase()}-${this.search_details.destinationCode.toUpperCase()}-UBR`);
      }
      this.loader = false;
    });



  }

  searchHelper(earnAndRedeemRes) {
    this.earnSearchFlights = earnAndRedeemRes[0].result;
    this.redeemSearchFlights = earnAndRedeemRes[1].result;
    this.filterFlights(this.earnSearchFlights.result, this.redeemSearchFlights.result, this.commonSearchFlights);
    let finalSearchResponse = this.formatResultData(this.commonSearchFlights, this.earnSearchFlights, this.redeemSearchFlights);
    this.tableData = [...finalSearchResponse];
  }

  downloadHelper(earnAndRedeemRes) {
    this.earnDownloadFlights = earnAndRedeemRes[0].result;
    this.redeemDownloadFlights = earnAndRedeemRes[1].result;
    this.filterFlights(this.earnDownloadFlights.result, this.redeemDownloadFlights.result, this.commonDownloadFlights);
    let finalDownloadResponse = this.formatResultData(this.commonDownloadFlights, this.earnDownloadFlights, this.redeemDownloadFlights);
    if (finalDownloadResponse.length === 0) {
      this.isSearchDataNotAvailable = true;
    } else {
      this.downloadCSVFile(finalDownloadResponse, `${this.search_details.originCode.toUpperCase()}-${this.search_details.destinationCode.toUpperCase()}`);
    }
  }

  countryCodeHelper() {
    let originCountryCodeData = airports.filter((city) => city.AIRLINE_CODE === this.search_details.originCode.toUpperCase())[0];
    this.search_details.originCountryCode = originCountryCodeData !== undefined ? originCountryCodeData.COUNTRY_CODE : "";

    let destCountryCodeData = airports.filter((city) => city.AIRLINE_CODE === this.search_details.destinationCode.toUpperCase())[0];
    this.search_details.destinationCountryCode = destCountryCodeData !== undefined ? destCountryCodeData.COUNTRY_CODE : "";

    this.search_details.isDomestic = this.search_details.originCountryCode === "IN" && this.search_details.destinationCountryCode === "IN" ? true : false;
  }

  getOriginalSearchObj() {
    return {
      originCode: "",
      originCountryCode: "",
      destinationCode: "",
      destinationCountryCode: "",
      bookingdate_from: new Date(),
      isDomestic: true,
      bookingdate_to: "",
      triptype: "1",
      class: "1",
      noOfAdult: 1,
      noOfChild: 0,
      noOfInfant: 0
    }
  }

  checkCityValidation(value: any, cityField: string) {
    let regx = /^[A-Za-z]+$/;
    let checkAlphabet = regx.test(value);
    if (!checkAlphabet) {
      this.displayCityNameErrors(true, cityField === "originCity" ? true : false)
      this.isCityNameError = true;
    } else {
      this.isCityNameError = false;
      this.displayCityNameErrors(false, cityField === "originCity" ? true : false)
    }

    if (value === "") {
      this.displayCityNameErrors(false, cityField === "originCity" ? true : false)
    }
    this.toggleSearchButton();
  }

  validate() {
    this.toggleSearchButton();
  }

  displayCityNameErrors(isError: boolean, isOriginCity: boolean) {
    if (isError) {
      isOriginCity ?
        document.getElementById("whereFromErr").innerHTML = "Accepts alphabets only" :
        document.getElementById("whereToErr").innerHTML = "Accepts alphabets only";
    } else {
      isOriginCity ?
        document.getElementById("whereFromErr").innerHTML = "" :
        document.getElementById("whereToErr").innerHTML = "";
    }
  }

  disableToBookingField() {
    this.search_details.bookingdate_to = "";
    this.search_minTodate = this.search_details.bookingdate_from;
    this.toggleSearchButton();
  }

  reset(formBtn: any) {
    if (formBtn === 'fromBookingDate') {
      this.fromDate.value = '';
      this.search_details.bookingdate_from = '';
      this.toDate.value = '';
      this.search_details.bookingdate_to = '';
    }

    if (formBtn === 'toBookingDate') {
      this.toDate.value = '';
      this.search_details.bookingdate_to = '';
    }
    this.toggleSearchButton();
  }

  fixInfantAndChildOptions() {
    this.infant_list = [];
    this.child_list = [];

    for (let i = 1; i <= this.search_details.noOfAdult; i++) {
      this.infant_list.push({ key: i, value: `${i}` });
    }

    for (let i = 1; i <= 9 - this.search_details.noOfAdult; i++) {
      this.child_list.push({ key: i, value: `${i}` });
    }
    this.toggleSearchButton();
  }

  downloadData() {
    /** 
     *  This way of matching using JSON.stringify is only because search_details and prev_searchDetails have same keys and in same order,
     *  otherwise use different matcher.
    */
    this.loader = true;
    this.isSearchDataNotAvailable = false;
    if (JSON.stringify(this.search_details) === JSON.stringify(this.prev_searchDetails) && this.tableData.length) {
      this.downloadCSVFile(this.tableData, `${this.search_details.originCode.toUpperCase()}-${this.search_details.destinationCode.toUpperCase()}`);
      this.loader = false;
    } else {
      this.commonDownloadFlights = [];
      this.getSearchResults("download");
    }


  }

  downloadResponseData() {
    this.loader = true;
    if (JSON.stringify(this.search_details) === JSON.stringify(this.prev_searchDetails)) {
      this.downloadJSONResponse(this.originalUBAResponse, `${this.search_details.originCode.toUpperCase()}-${this.search_details.destinationCode.toUpperCase()}-UBA`);
      this.downloadJSONResponse(this.originalUBRResponse, `${this.search_details.originCode.toUpperCase()}-${this.search_details.destinationCode.toUpperCase()}-UBR`);
      this.loader = false;
    } else {
      this.getSearchResults("download-response");
    }

  }

  toggleSearchButton() {
    if (this.search_details.originCode.length === 3 &&
      this.search_details.destinationCode.length === 3 && this.search_details.bookingdate_from !== "" && !this.isCityNameError) {
      this.isSearchBtnDisable = false;
    } else {
      this.isSearchBtnDisable = true;
    }
    this.isSearchDataNotAvailable = false;
    this.isDownloadBtnDisable = false;
    this.searchResultMessage = "No Result";
  }

  formatSearchRequest(data: any, isEarn: boolean) {

    let formattedOnwardDate = this.getTransformedDate(this.search_details.bookingdate_from)
    let formattedReturnDate = this.getTransformedDate(this.search_details.bookingdate_to);

    let flightType = this.search_details.isDomestic ? "D" : "I";

    let SID = this.getSID("" + data.originCode + data.destinationCode + data.noOfAdult + data.noOfChild + data.noOfInfant + formattedOnwardDate + formattedReturnDate + flightType + data.class);

    let req = {
      "origin": data.originCode.toUpperCase(),
      "destination": data.destinationCode.toUpperCase(),
      "triptype": data.triptype,
      "cabinclass": data.class,
      "noofadults": data.noOfAdult,
      "noofchilds": data.noOfChild,
      "noofinfants": data.noOfInfant,
      "excludelccsearch": "",
      "isnearbyairportsearch": "",
      "isnonstopsearch": "",
      "onwarddate": formattedOnwardDate,
      "returndate": data.bookingdate_to === "" ? "" : formattedReturnDate,
      "flighttype": flightType,
      "curr": "INR",
      "sid": SID,
      "isearn": isEarn,
      "result_all": true,
      "search_details": {},
      "jpnumber": "",
      "search_id": SID,
      "uid": "03a2dbbe-eb89-494d-b329-6ee10a977acd",
      "startindex": "0",
      "resultcount": "5000",
      "fareindicator": isEarn && this.search_details.isDomestic ? ["REGR", "FLEX"] : [],
      "requestID": "",
      "affiliateID": "",
      "utm_content": "",
      "utm_medium": "",
      "utm_source": "",
      "utm_campaign": "",
      "utm_marketing_channel": "",
      "isSearchCompareCall": true
    }

    return req;
  }

  getTransformedDate(date: any) {
    return this.datePipe.transform(
      date,
      "yyyy-MM-dd"
    );
  }

  formatResultData(commonFlight: any, earnFlights: any, redeemFlights: any) {
    let finalResponse = [];

    // Common flights
    if (commonFlight.length > 0) {
      commonFlight.forEach((item: any) => {
        finalResponse.push({
          flightDetails: `${item[0].bnds[0].acd} - ${item[0].bnds[0].fno}` + (!this.search_details.isDomestic && this.search_details.triptype === "2" ? `/${item[0].bnds[1].acd} - ${item[0].bnds[1].fno}` : ""),
          flightType: this.transformText(item[0].bnds[0].btnm) + (!this.search_details.isDomestic && this.search_details.triptype === "2" ? "/" + this.transformText(item[0].bnds[1].btnm) : ""),
          noOfStops: item[0].stp,
          deptTime: item[0].dtym,
          arrTime: item[0].atym,
          earnPrice: item[0].bnds[0].tfwm,
          redeemPrice: item[1].bnds[0].tfwm,
          journeyDate: !this.search_details.isDomestic && this.search_details.triptype === "2" ? item[0].ddt + " / " + this.getTransformedDate(this.search_details.bookingdate_to) : item[0].ddt
        })
      });
    }

    // Earn flights
    if (earnFlights.result.length > 0) {
      earnFlights.result.forEach((item: any) => {
        finalResponse.push({
          flightDetails: `${item.bnds[0].acd} - ${item.bnds[0].fno}` + (!this.search_details.isDomestic && this.search_details.triptype === "2" ? `/${item.bnds[1].acd} - ${item.bnds[1].fno}` : ""),
          flightType: this.transformText(item.bnds[0].btnm) + (!this.search_details.isDomestic && this.search_details.triptype === "2" ? "/" + this.transformText(item.bnds[1].btnm) : ""),
          noOfStops: item.stp,
          deptTime: item.dtym,
          arrTime: item.atym,
          earnPrice: item.bnds[0].tfwm + "",
          redeemPrice: "NA",
          journeyDate: !this.search_details.isDomestic && this.search_details.triptype === "2" ? item.ddt + " / " + this.getTransformedDate(this.search_details.bookingdate_to) : item.ddt
        })
      });
    }

    // Redeem flights
    if (redeemFlights.result.length > 0) {
      redeemFlights.result.forEach((item: any) => {
        finalResponse.push({
          flightDetails: `${item.bnds[0].acd} - ${item.bnds[0].fno}` + (!this.search_details.isDomestic && this.search_details.triptype === "2" ? `/${item.bnds[1].acd} - ${item.bnds[1].fno}` : ""),
          flightType: this.transformText(item.bnds[0].btnm) + (!this.search_details.isDomestic && this.search_details.triptype === "2" ? "/" + this.transformText(item.bnds[1].btnm) : ""),
          noOfStops: item.stp,
          deptTime: item.dtym,
          arrTime: item.atym,
          earnPrice: "NA",
          redeemPrice: item.bnds[0].tfwm + "",
          journeyDate: !this.search_details.isDomestic && this.search_details.triptype === "2" ? item.ddt + " / " + this.getTransformedDate(this.search_details.bookingdate_to) : item.ddt
        })
      });
    }

    return finalResponse;
  }


  isFlightInUBR(ubaFlightItem: any, ubrFlights: any, commonFlights: any) {

    // Step twp of filtering flights

    for (let ubrFlightItem = 0; ubrFlightItem < ubrFlights.length; ubrFlightItem++) {

      if (!this.search_details.isDomestic && this.search_details.triptype === "2") {
        // flight code match - International return type
        if (ubaFlightItem.bnds[0].acd === ubrFlights[ubrFlightItem].bnds[0].acd && ubaFlightItem.bnds[1].acd === ubrFlights[ubrFlightItem].bnds[1].acd &&
          ubaFlightItem.bnds[0].fno === ubrFlights[ubrFlightItem].bnds[0].fno && ubaFlightItem.bnds[1].fno === ubrFlights[ubrFlightItem].bnds[1].fno &&
          ubaFlightItem.stp === ubrFlights[ubrFlightItem].stp &&
          ubaFlightItem.dtym === ubrFlights[ubrFlightItem].dtym && ubaFlightItem.atym === ubrFlights[ubrFlightItem].atym &&
          ubaFlightItem.bnds[0].pax[0].bgwgt === ubrFlights[ubrFlightItem].bnds[0].pax[0].bgwgt &&
          ubaFlightItem.bnds[1].pax[0].bgwgt === ubrFlights[ubrFlightItem].bnds[1].pax[0].bgwgt) {
          // this is common flight
          commonFlights.push([ubaFlightItem, ubrFlights[ubrFlightItem]]);
          ubrFlights.splice(ubrFlightItem, 1);
          return true;
        }
      } else {
        // flight code match - Domestic
        if (ubaFlightItem.bnds[0].acd === ubrFlights[ubrFlightItem].bnds[0].acd &&
          ubaFlightItem.bnds[0].fno === ubrFlights[ubrFlightItem].bnds[0].fno &&
          ubaFlightItem.stp === ubrFlights[ubrFlightItem].stp &&
          ubaFlightItem.dtym === ubrFlights[ubrFlightItem].dtym && ubaFlightItem.atym === ubrFlights[ubrFlightItem].atym &&
          ubaFlightItem.bnds[0].pax[0].bgwgt === ubrFlights[ubrFlightItem].bnds[0].pax[0].bgwgt) {
          // this is common flight
          commonFlights.push([ubaFlightItem, ubrFlights[ubrFlightItem]]);
          ubrFlights.splice(ubrFlightItem, 1);
          return true;
        }
      }

    }

    return false;
  }

  filterFlights(ubaFlights: any, ubrFlights: any, commonFlights: any) {
    // step one of filtering flights
    for (let ubaFlightItem = 0; ubaFlightItem < ubaFlights.length; ubaFlightItem++) {
      if (this.isFlightInUBR(ubaFlights[ubaFlightItem], ubrFlights, commonFlights)) {
        ubaFlights.splice(ubaFlightItem, 1);
        ubaFlightItem--;
      }
    }
  }

  getSID = (data: any) => {
    var t = Buffer.from(data, 'utf8').toString('hex');
    return t;
  }

  downloadCSVFile(data: any, fileName: string) {
    const replacer = (key, value) => value === null ? '' : value;
    let header = Object.keys(data[0]);
    let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    header = Object.values(this.csvHeaderFileObj);
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    let blob = new Blob([csvArray], { type: 'text/csv' })
    saveAs(blob, `${fileName}.csv`);
  }

  downloadJSONResponse(searchResponse: any, fileName: string) {
    const blobConfig = new Blob(
      [JSON.stringify(searchResponse)],
      { type: 'text/json;charset=utf-8' }
    )
    saveAs(blobConfig, `${fileName}.json`)
  }

  transformText(text: string) {
    /**
     * InBound => Inbound
     * inbound => Inbound
     */
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }
}

